import { defaultClauseStatus } from "./constants";
import {
  PromptManagementValidations,
  SYNC_CONTRACTS_ERRORS,
} from "./Pages/constants";
import {
  ISyncContractsModalData,
  ISyncContractsModalDataErrors,
} from "./Pages/SyncContracts/SyncContracts.types";

export const getClauseItemsForContractReview = (clause?: string) => {
  if (!clause) return [];

  const items = clause
    .split("\n")
    .map((item) => item.trim())
    // Ignore empty lines or lines without the expected key:value structure
    .filter((item) => item && item.includes(":"));

  const data: any[] = [];

  for (let i = 0; i < items.length; i++) {
    const parts = items[i].split(":");
    const rawName = parts[0];
    const rawNumber = parts[1];

    if (rawName == null || rawNumber == null) {
      continue;
    }

    const name: any = rawName.trim();
    const number = rawNumber.trim();
    if (!name || !number) {
      continue;
    }

    const parsedNumber = parseFloat(number);
    if (Number.isNaN(parsedNumber)) {
      continue;
    }
    const subclauses = Object.values(
      PromptManagementValidations.CONTRACT_REVIEW
    );
    const rulesObjects = subclauses.map((subclause: any) => subclause?.rules);
    let ruleKeys = [];
    let rulesObj: any = {};
    for (let idx = 0; idx < rulesObjects.length; idx++) {
      const rule = rulesObjects[idx];
      for (let [key, val] of Object.entries(rule)) {
        ruleKeys.push(key);
        rulesObj = { ...rulesObj, [key]: val };
      }
    }
    const itemData = {
      name: name,
      count: parsedNumber,
      unit: rulesObj?.[name]?.unit,
      ...rulesObj?.[name],
    };
    data.push(itemData);
  }
  return data;
};

export const getRuleForSavingForContractReview = (
  rules: { name: string; count: number; unit: string }[]
) => {
  let str = "";
  rules?.forEach((rule) => {
    const unit = rule?.unit ?? "%";
    str += rule?.name + ": " + rule?.count + unit + "\n";
  });
  return str;
};

export const getRefinedValuePerUnit = (
  item: any,
  val: any,
  isDefaultVal: boolean
) => {
  switch (item?.unit) {
    case "%":
      if (val > 100) {
        val = 100;
      }
      break;
    case "$":
      break;
    default:
      break;
  }
  return isDefaultVal ? item?.count : val;
};

export const getClauseItemsForTTC = (clause: string) => {
  const items = clause
    .split("\n")
    .map((item) => item.trim())
    .filter((item) => item);

  let values = [];
  for (let i = 0; i < items.length; i++) {
    const keyValPair = items[i].split(":");
    const key = keyValPair[0].trim();
    const val = keyValPair[1].trim();
    const synonyms = val.replace(/['"]+/g, "").split(/\s*,\s*/);
    values.push({
      [key]: key === "Word" ? synonyms[0] : synonyms,
      type: defaultClauseStatus.DEFAULT,
    });
  }

  const clubbedValues = [];
  for (let i = 0; i < values.length - 1; i += 2) {
    const item = values[i];
    const val = values[i + 1];
    const obj = {
      ...item,
      ...val,
    };

    clubbedValues.push(obj);
  }

  return clubbedValues;
};

export const getRuleForSavingForTTC = (
  rules: { Word: string; Synonyms: string[]; type: string }[]
) => {
  let str = "";
  rules?.forEach((rule) => {
    str += "Word: " + `"${rule?.Word}"` + "\n";
    str += "Synonyms: ";
    rule?.Synonyms?.forEach((synonym, idx) => {
      str += `"${synonym}" `;
      if (idx !== rule?.Synonyms?.length - 1) {
        str += ", ";
      }
    });
    str += "\n\n";
  });
  return str;
};

export const validateSyncContractsModalFields = (
  syncContractsModalData: ISyncContractsModalData
) => {
  let errorsObj: ISyncContractsModalDataErrors = {
    dest_drive_folder: "",
    vertical: "",
    year: "",
    src_drive_folder: "",
  };
  Object.keys(errorsObj).forEach((key) => {
    const data =
      syncContractsModalData[key as keyof typeof syncContractsModalData];
    if (!data) {
      errorsObj = {
        ...errorsObj,
        [key]: SYNC_CONTRACTS_ERRORS[key as keyof typeof SYNC_CONTRACTS_ERRORS],
      };
    }
  });

  if (
    syncContractsModalData.src_drive_folder.length > 0 &&
    syncContractsModalData.src_drive_folder ===
      syncContractsModalData.dest_drive_folder
  ) {
    errorsObj = {
      ...errorsObj,
      src_drive_folder: SYNC_CONTRACTS_ERRORS.drive_links_same,
      dest_drive_folder: SYNC_CONTRACTS_ERRORS.drive_links_same,
    };
  }

  return errorsObj;
};

export const setErrorsWhileUpdatingValue = (data: any, setErrors: any) => {
  Object.keys(data).forEach((key) => {
    const isDataEmpty =
      data[key] === undefined || data[key] === null || data[key] === "";
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [key]: isDataEmpty
        ? SYNC_CONTRACTS_ERRORS[key as keyof typeof SYNC_CONTRACTS_ERRORS]
        : "",
    }));
  });
};

 // ✅ Common utility method for timezone conversion with timezone display
  export const convertToLocalTime = (utcTimeString: string): string => {
    if (utcTimeString === 'Still active') {
      return 'Still active';
    }

    try {
      const utcDate = new Date(utcTimeString);
      
      if (isNaN(utcDate.getTime())) {
        console.error('Invalid date:', utcTimeString);
        return utcTimeString;
      }

      // Get date components
      const month = String(utcDate.getMonth() + 1).padStart(2, '0');
      const day = String(utcDate.getDate()).padStart(2, '0');
      const year = utcDate.getFullYear();
      
      // Get time components
      let hours = utcDate.getHours();
      const minutes = String(utcDate.getMinutes()).padStart(2, '0');
      const seconds = String(utcDate.getSeconds()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert to 12-hour format
      

       // Get timezone offset
        const offsetMinutes = -utcDate.getTimezoneOffset();
        const offsetHours = offsetMinutes / 60;
        
        // Map common timezones (add more as needed)
        const timezoneMap: Record<string, string> = {
          '5.5': 'IST',
          '0': 'GMT',
          '1': 'CET',
          '-10': 'HST',    // Hawaii (no DST)
          '-9': 'AKST',    // Alaska Standard
          '-8': 'PST',     // Pacific Standard (or AKDT in summer)
          '-7': 'MST',     // Mountain Standard (or PDT in summer)
          '-6': 'CST',     // Central Standard (or MDT in summer)
          '-5': 'EST',     // Eastern Standard (or CDT in summer)
          '-4': 'EDT',     // Eastern Daylight (or AST)
        };
 
    
        const timezone = timezoneMap[offsetHours.toString()] || `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`;

        // Format: MM-DD-YYYY, HH:MM:SS AM/PM TIMEZONE
        return `${month}-${day}-${year}, ${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm} ${timezone}`;
        
    } catch (error) {
      console.error('Error converting time:', error);
      return utcTimeString;
    }
  };
